var panasonic_N2QAYB000010 = {
    name: "N2QAYB000010",
    defaultCommandIndex: 1,
    commands: [
        {
            function: "KEY_POWER",
            name: "KEY_POWER",
            icon: "KEY_POWER",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,254,213,118,174,136],
        },
        {
            // function: "KEY_TV",
            function: "KEY_SOURCE",
            name: "KEY_SOURCE",
            icon: "KEY_SOURCE",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,255,171,186,174,32],
        },
        {
            function: "band",
            name: "band",
            icon: "band",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,191,221,191,226],
        },
        {
            function: "KEY_TUNER",
            name: "KEY_TUNER",
            icon: "KEY_TUNER",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,255,119,110,184,128],
        },
        {
            function: "dvr/dvd-p",
            name: "dvr/dvd-p",
            icon: "dvr/dvd-p",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,254,170,234,170,226],
        },
        {
            function: "tv_vol+",
            name: "tv_vol+",
            icon: "tv_vol+",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,247,255,239,246,136],
        },
        {
            function: "tv_vol-",
            name: "tv_vol-",
            icon: "tv_vol-",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,247,253,247,125,162],
        },
        {
            function: "tv/av",
            name: "tv/av",
            icon: "tv/av",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,247,253,191,111,162],
        },
        {
            function: "KEY_MUTE",
            name: "KEY_MUTE",
            icon: "KEY_MUTE",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,255,117,238,232,128],
        },
        {
            function: "KEY_VOLUMEUP",
            name: "KEY_VOLUMEUP",
            icon: "KEY_VOLUMEUP",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,255,247,254,136],
        },
        {
            function: "KEY_VOLUMEDOWN",
            name: "KEY_VOLUMEDOWN",
            icon: "KEY_VOLUMEDOWN",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,254,251,191,162],
        },
        {
            function: "KEY_1",
            name: "KEY_1",
            icon: "KEY_1",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,247,253,162],
        },
        {
            function: "KEY_2",
            name: "KEY_2",
            icon: "KEY_2",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,123,223,104,128],
        },
        {
            function: "KEY_3",
            name: "KEY_3",
            icon: "KEY_3",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,187,239,104,128],
        },
        {
            function: "KEY_4",
            name: "KEY_4",
            icon: "KEY_4",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,93,235,218,32],
        },
        {
            function: "KEY_5",
            name: "KEY_5",
            icon: "KEY_5",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,219,247,104,128],
        },
        {
            function: "KEY_6",
            name: "KEY_6",
            icon: "KEY_6",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,109,237,218,32],
        },
        {
            function: "KEY_7",
            name: "KEY_7",
            icon: "KEY_7",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,173,245,218,32],
        },
        {
            function: "KEY_8",
            name: "KEY_8",
            icon: "KEY_8",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,86,245,118,136],
        },
        {
            function: "KEY_9",
            name: "KEY_9",
            icon: "KEY_9",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,235,251,104,128],
        },
        {
            function: "KEY_0",
            name: "KEY_0",
            icon: "KEY_0",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,117,238,218,32],
        },
        {
            function: "KEY_SUBTITLE",
            name: "KEY_SUBTITLE",
            icon: "KEY_SUBTITLE",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,254,219,86,213,136],
        },
        {
            function: "X_KEY_0+",
            name: "X_KEY_0+",
            icon: "X_KEY_0+",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,119,174,174,32],
        },
        {
            function: "skip_back",
            name: "skip_back",
            icon: "skip_back",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,119,110,170,136],
        },
        {
            function: "skip_forward",
            name: "skip_forward",
            icon: "skip_forward",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,183,118,170,136],
        },
        {
            function: "KEY_REWIND",
            name: "KEY_REWIND",
            icon: "KEY_REWIND",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,223,237,104,128],
        },
        {
            function: "KEY_FASTFORWARD",
            name: "KEY_FASTFORWARD",
            icon: "KEY_FASTFORWARD",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,111,219,90,32],
        },
        {
            function: "KEY_STOP",
            name: "KEY_STOP",
            icon: "KEY_STOP",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,255,245,162],
        },
        {
            function: "KEY_PAUSE",
            name: "KEY_PAUSE",
            icon: "KEY_PAUSE",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,175,235,90,32],
        },
        {
            function: "KEY_PLAY",
            name: "KEY_PLAY",
            icon: "KEY_PLAY",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,254,250,226],
        },
        {
            function: "top_menu",
            name: "top_menu",
            icon: "top_menu",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,90,234,219,136],
        },
        {
            function: "direct_tuning",
            name: "direct_tuning",
            icon: "direct_tuning",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,86,218,186,162],
        },
        {
            function: "KEY_UP",
            name: "KEY_UP",
            icon: "KEY_UP",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,111,173,174,32],
        },
        {
            function: "KEY_DOWN",
            name: "KEY_DOWN",
            icon: "KEY_DOWN",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,175,181,174,32],
        },
        {
            function: "KEY_LEFT",
            name: "KEY_LEFT",
            icon: "KEY_LEFT",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,87,213,107,136],
        },
        {
            function: "KEY_RIGHT",
            name: "KEY_RIGHT",
            icon: "KEY_RIGHT",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,239,122,184,128],
        },
        {
            function: "KEY_ENTER",
            name: "KEY_ENTER",
            icon: "KEY_ENTER",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,173,255,127,94,184,128],
        },
        {
            function: "effect",
            name: "effect",
            icon: "effect",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,170,173,91,226],
        },
        {
            function: "c.focus",
            name: "c.focus",
            icon: "c.focus",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,174,170,175,98],
        },
        {
            function: "KEY_KPMINUS",
            name: "KEY_KPMINUS",
            icon: "KEY_KPMINUS",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,181,90,239,136],
        },
        {
            function: "KEY_KPPLUS",
            name: "KEY_KPPLUS",
            icon: "KEY_KPPLUS",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,234,183,190,32],
        },
        {
            function: "level",
            name: "level",
            icon: "level",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,213,91,111,136],
        },
        {
            function: "test",
            name: "test",
            icon: "test",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,214,171,125,136],
        },
        {
            function: "off",
            name: "off",
            icon: "off",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,213,182,215,136],
        },
        {
            function: "dolby_pl2",
            name: "dolby_pl2",
            icon: "dolby_pl2",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,221,109,126,32],
        },
        {
            function: "KEY_AUDIO",
            name: "KEY_AUDIO",
            icon: "KEY_AUDIO",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,189,118,250,32],
        },
        {
            function: "movie",
            name: "movie",
            icon: "movie",
            command: [100,0,4,72,2,27,1,72,2,130,4,110,14,206,5,63,2,189,32,55,255,191,219,183,253,187,120,128],
        },
    ]
}
export default panasonic_N2QAYB000010